export enum EPaymentImageType {
    CUSTOM = 'custom'
}
